<template>
    <div class="toggle-control flex items-center justify-between px-2 py-2">
        <label :for="id" class="toggle-label mb-0">{{ label }}</label>
        <div class="custom-control custom-switch">
            <input
                :id="id"
                type="checkbox"
                class="custom-control-input"
                :checked="enabled"
                @change="$emit('input', $event.target.checked ? trueValue : falseValue)"
            />
            <label class="custom-control-label" :for="id">{{ enabled ? activeLabel : inactiveLabel }}</label>
        </div>
    </div>
</template>

<script>
export default {
    name: "AdminToggleField",
    props: {
        id: { type: String, required: true },
        label: { type: String, required: true },
        value: { default: null },
        activeValues: { type: Array, default: () => [1, "1", "y", true] },
        trueValue: { default: 1 },
        falseValue: { default: null },
        activeLabel: { type: String, default: "On" },
        inactiveLabel: { type: String, default: "Off" },
    },
    computed: {
        enabled() {
            return this.activeValues.some(value => value === this.value);
        },
    },
};
</script>

<style scoped lang="scss">
.toggle-control {
    border-bottom: 1px solid var(--color-light-grey);

    &:last-child {
        border-bottom: 0;
    }
}

.toggle-label {
    color: var(--color-mine-shaft);
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-semibold);
}

.custom-control-label {
    color: var(--color-pip-gray);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-semibold);
}
</style>
